// This file is generated automatically by scripts/generate-icon.js. Don't modify it.

import RTTaiwanBrandHorizontal from '../_raw/ui/icon_RT_Taiwan_Brand_Horizontal.svg';
import withIconProps from '../withIconProps';

export default withIconProps(RTTaiwanBrandHorizontal, {
  shouldSetDefaultSize: true,
  defaultHeight: 32,
  defaultWidth: 192,
});
